<template>
  <el-dialog
    title="Filtros"
    :visible.sync="visible"
    :fullscreen="true"
    center>
    <el-row>
      <el-col :span="6">
        <el-tree
          :data="centroCustolistTree"
          show-checkbox
          :default-checked-keys="centrosSelecteds"
          default-expand-all
          ref="tree"
          highlight-current
          node-key="id"
          :props="defaultProps">
        </el-tree>
      </el-col>
      <el-col :span="3">
        <el-checkbox-group v-model="anosSelecteds">
          <ul>
            <li v-for="item in anos">
              <el-checkbox-button :label="item" :key="item" width="100%" >{{item}}</el-checkbox-button>
            </li>
          </ul>
        </el-checkbox-group>
      </el-col>
      <el-col :span="3" class="mr-2">
        <el-checkbox-group v-model="mesesSelecteds">
          <ul>
            <li v-for="item in meses">
              <el-checkbox-button :label="item.mes" :key="item.mes" width="100%"> {{item.nome}}</el-checkbox-button>
            </li>
          </ul>
        </el-checkbox-group>
      </el-col>
      <el-col :span="10" class="mr-2">
        <el-tree
          :data="indicadorlistTree"
          show-checkbox
          ref="treeindicador"
          highlight-current
          node-key="id"
          :props="defaultProps">
        </el-tree>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="aplicar()">Aplicar</el-button>
  </span>
  </el-dialog>

</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "FilterGraph",
    props: ['showfilter'],
    computed: {
      ...mapGetters(['centroCustolistTree' , 'indicadorlistTree'  ]),
      ...mapState([ 'anos', 'meses', 'mesSelected', 'anoSelected', 'centroCustoList']),
    },
    data() {
      return {
        visible: false,
        indicadoresSelected: [],
        anosSelecteds: [],
        mesesSelecteds: [],
        centrosSelecteds: [],
        defaultProps: {
          children: 'children',
          label: 'nome'
        }
      }
    },
    watch: {
      showfilter: function (val, oldVal) {
        this.visible = val;
      },
      visible: function (val, oldVal) {
        this.$emit('update:showfilter', val)
      }
    },
    methods: {
      aplicar() {
        const {mesesSelecteds, anosSelecteds} = this
        const centrosSelecteds = this.$refs.tree.getCheckedKeys()
        const indicadoresSelected = this.$refs.treeindicador.getCheckedKeys()
        this.$emit('filtroAplicado', {mesesSelecteds, anosSelecteds,centrosSelecteds,indicadoresSelected})
        this.visible = false
      }
    },
    mounted() {
      this.anosSelecteds.push(this.anoSelected)
      this.mesesSelecteds.push(this.mesSelected)
      this.centrosSelecteds = collect(this.centroCustoList).pluck('id').all()
    }
  }
</script>

<style scoped>
  .el-checkbox-button .el-checkbox-button__inner {
    width: 100%;
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content{
    background-color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/FilterGraph/index.vue